import { styled } from 'styled-components';

export const FormationDetailFilterContainer = styled.div`
  dialog {
    > header:first-of-type {
      display: none;
    }

    > div {
      padding: 0;
    }

    > footer:first-of-type {
      display: none;
    }

    hr {
      margin: 0 ${({ theme }) => theme.sizing.large};
      border-top: 1px solid
        ${({ theme }) => theme.colours.canvas.secondary.main};
    }
  }
`;

export const FormationDetailFilterHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.sizing.large};
  background-color: ${({ theme }) => theme.colours.canvas.secondary.main};
  ${({ theme }) => theme.typography.headingLarge}
`;

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.regular};

  h2 {
    margin: 0;
  }

  path {
    fill: ${({ theme }) =>
      theme.applyOpacity(theme.colours.ink.primary.main, 'secondary')};
  }
`;

export const FormationDetailFilterFooter = styled.header`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: ${({ theme }) => theme.sizing.large};
  gap: ${({ theme }) => theme.sizing.regular};
  background-color: ${({ theme }) => theme.colours.canvas.secondary.main};
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.sizing.large};
  gap: ${({ theme }) => theme.sizing.large};

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${({ theme }) => theme.typography.headingMedium}

    > div {
      display: flex;
      align-items: center;
      gap: ${({ theme }) => theme.sizing.regular};
    }
  }

  .options {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: ${({ theme }) => theme.sizing.large};
    padding: 0 ${({ theme }) => theme.sizing.regular};

    label {
      max-width: 10.4rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

FormationDetailFilterContainer.displayName = 'FormationDetailFilterContainer';
FormationDetailFilterHeader.displayName = 'FormationDetailFilterHeader';
FormationDetailFilterFooter.displayName = 'FormationDetailFilterFooter';
FilterSection.displayName = 'FilterSection';
